import React from 'react';
import PropTypes from 'prop-types';

// On desktop and tablet, show children as columns
// On mobile, stack children vertically

const DesktopColumnsMobileStack = ({ children, className = '' }) => (
  <div
    className={`flex flex-col w-full md:flex-row [&_>_*]:md:flex-1 [&_>_*_+_*]:mt-8 [&_>_*_+_*]:md:ml-8 [&_>_*_+_*]:md:mt-0 ${className}`}
  >
    {children}
  </div>
);

DesktopColumnsMobileStack.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default DesktopColumnsMobileStack;
